/**
 * `AuditPage` — Main audit drawer page (/workspace/audit)
 *
 * Renders the session audit drawer in full-page mode.
 * Handles routing to sub-pages like row detail and evidence pack.
 */

import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuditDrawer } from '@/components/audit/AuditDrawer';
import { EvidencePackPanel } from '@/components/audit/EvidencePackPanel';
// import { AdminAuditPivot } from '@/components/audit/AdminAuditPivot';
import type { AuditFilters } from '@/app/audit/auditDataClient';

export function AuditPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [evidencePackOpen, setEvidencePackOpen] = useState(false);
  const [evidencePackRowId, setEvidencePackRowId] = useState<string>();

  const sessionId = searchParams.get('session_id') || undefined;
  const focusRowId = searchParams.get('focus') || undefined;

  const handleRowClick = (rowId: string) => {
    navigate(`/workspace/audit/row/${rowId}`);
  };

  const handleEvidencePackRequested = (selectedRows: string[]) => {
    // For simplicity, use first selected row
    setEvidencePackRowId(selectedRows[0]);
    setEvidencePackOpen(true);
  };

  const handleFullAuditRequested = (_filters: AuditFilters) => {
    // This will be handled by AdminAuditPivot component
    // For now, we'll just open it without specific filters
    const adminPivot = document.querySelector('[aria-label*="full audit"]') as HTMLElement;
    adminPivot?.click();
  };

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AuditDrawer
        sessionId={sessionId}
        focusRowId={focusRowId}
        onRowClick={handleRowClick}
        onEvidencePackRequested={handleEvidencePackRequested}
        onFullAuditRequested={handleFullAuditRequested}
      />
      
      <EvidencePackPanel
        isOpen={evidencePackOpen}
        onClose={() => setEvidencePackOpen(false)}
        rowId={evidencePackRowId}
      />
    </div>
  );
}